import { render } from "./FormManterPrazoAudiometria.vue?vue&type=template&id=2349ee2f"
import script from "./FormManterPrazoAudiometria.vue?vue&type=script&lang=js"
export * from "./FormManterPrazoAudiometria.vue?vue&type=script&lang=js"

import "./FormManterPrazoAudiometria.vue?vue&type=style&index=0&id=2349ee2f&lang=css"
/* custom blocks */
import block0 from "./FormManterPrazoAudiometria.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__